
let workerInstance = null;
let currentUrl = null;

let cachedData = {
  logs: "",
  status: "streaming",
};

function keepLastNLines(str, maxLines) {
  if (!str) return "";
  const lines = str.split("\n");
  if (lines.length <= maxLines) return str;
  return lines.slice(-maxLines).join("\n");
}

/**
 * mode:
 *  - "append_tail": append incoming lines but keep only last `maxLines`
 *  - "replace": replace logs with incoming payload (used for paginated logs)
 */
export function initLogsWorker(
  newUrl,
  token,
  onMessage,
  onError,
  { mode = "append_tail", maxLines = 500 } = {}
) {
  if (newUrl === currentUrl && workerInstance) {
    onMessage(cachedData);
    return;
  }

  terminateLogsWorker();

  const workerPath = new URL("./logsSSEWorker.js", import.meta.url);
  workerInstance = new Worker(workerPath, { type: "module" });
  currentUrl = newUrl;

  cachedData = { logs: "", status: "streaming" };

  workerInstance.postMessage({ url: newUrl, token });

  // workerInstance.onmessage = (event) => {
  //   const msg = event.data;

  //   if (msg.type === "log") {
  //     if (mode === "replace") {
  //       // Replace full view with whatever backend sent
  //       cachedData.logs = msg.logs;
  //     } else {
  //       // Append but keep bounded memory
  //       cachedData.logs = keepLastNLines(cachedData.logs + msg.logs + "\n", maxLines);
  //     }

  //     onMessage({ ...cachedData });
  //   }

  //   if (msg.type === "error") {
  //     onError?.(msg.message);
  //   }
  // };
  let pageBuffer = [];   // used only for history mode

workerInstance.onmessage = (event) => {
  const msg = event.data;

  if (msg.type === "log") {

    // ------------------------
    // TAIL MODE (running live)
    // ------------------------
    if (mode === "append_tail") {
      cachedData.logs = keepLastNLines(
        cachedData.logs + msg.logs + "\n",
        maxLines
      );

      onMessage({ ...cachedData });
      return;
    }

    // ------------------------
    // HISTORY MODE (paginated)
    // ------------------------
    if (mode === "replace") {
      pageBuffer.push(msg.logs);
      return; // DO NOT update UI yet
    }
  }

  // ------------------------
  // HANDLE STREAM DONE
  // ------------------------
  if (msg.type === "done") {
    if (mode === "replace") {
      cachedData.logs = pageBuffer.join("\n");
      pageBuffer = [];
      onMessage({ ...cachedData });
    }
  }

  if (msg.type === "error") {
    onError?.(msg.message);
  }
};
}

export function terminateLogsWorker() {
  if (workerInstance) {
    workerInstance.terminate();
    workerInstance = null;
  }
  currentUrl = null;
  cachedData = { logs: "", status: "streaming" };
}